import React, { useState, useEffect } from 'react';
import { IoMdArrowRoundDown, IoMdArrowRoundUp } from 'react-icons/io';
import * as Style from './style';
import Card from './components/Card';
import Flex from './components/Flex';
import Button from './components/Button';
import VideoFrame from './components/VideoFrame';
import Map from './components/Map';
import { ReactComponent as Snap } from './assets/icons/Snap.svg';
import { ReactComponent as IconCheck } from './assets/icons/iconcheck.svg';
import { ReactComponent as IconEye } from './assets/icons/iconeye.svg';
import { ReactComponent as IconMoney } from './assets/icons/iconmoney.svg';
import { ReactComponent as IconCrown } from './assets/icons/iconcrown.svg';
import megatvLogo from './assets/logos/megatv.svg';
import sbtLogo from './assets/logos/sbt.svg';
import bandLogo from './assets/logos/band.svg';

import { color, fontWeight } from './services/settings.json';
import tvChannels from './services/tvChannels.json';

const pdfFile = 'https://static-campanhas.webmotors.com.br/downloads/Webmotors-TV.pdf';

const Logos = {
	megatv: megatvLogo,
	band: bandLogo,
	sbt: sbtLogo,
};

const WithProduct = () => {
	const [selectedState, setSelectedState] = useState('SP');
	const [tvState, setTvState] = useState(tvChannels[selectedState]);
	const [fadeStateClass, setFadeStateClass] = useState(false);
	const [currentChannel, setCurrentChannel] = useState({ id: 1 });

	const setTvPromise = () => {
		const promise = new Promise((resolve) => {
			const selectedStateChannels = tvChannels[selectedState];
			setFadeStateClass(false);
			setTvState(tvChannels[selectedState]);
			setCurrentChannel(selectedStateChannels.tvChannel[0]);
			resolve();
		});
		return promise;
	};

	useEffect(() => {
		setTvPromise().then(() => {
			setFadeStateClass(true);
		});
	}, [selectedState]);

	const changeChannel = (action) => {
		const { id } = currentChannel;
		const newId = action === 'next' ? id : id - 2;
		const newCurrentChannel = tvState.tvChannel[newId];

		if (newCurrentChannel !== undefined) {
			return setCurrentChannel(newCurrentChannel);
		}

		return false;
	};

	const redirectForm = () => window.open('https://www.surveygizmo.com/s3/5963579/Interesse-WebTV');

	return (
		<Flex direction="column" padding="32px" style={{ paddingLeft: '80px' }}>
			<h1 style={{ fontWeight: fontWeight.semiBold, fontSize: '28px', color: color.gray }}>Webmotors TV</h1>
			<Card
				title="Para você anunciar sua loja na TV, dentro de um programa direcionado para os amantes do mundo automotivo."
				icon={(<Snap />)}
				margin="14px 0 0 0"
			>
				<Flex direction="column">
					<Style.Title>Vantagens de anunciar na Webmotors TV</Style.Title>
					<Flex
						justify="space-between"
						width="100%"
						padding="0 30px"
						margin="13px 0 0"
					>
						<Style.LastProductInfo direction="column">
							<IconCrown />
							<em>Autoridade da Webmotors no setor automotivo.</em>
						</Style.LastProductInfo>
						<Style.LastProductInfo direction="column">
							<IconEye />
							<em>Visibilidade para sua loja na região.</em>
						</Style.LastProductInfo>
						<Style.LastProductInfo direction="column">
							<IconMoney />
							<em>Potencialização das vendas.</em>
						</Style.LastProductInfo>
						<Style.LastProductInfo direction="column">
							<IconCheck />
							<em>Ser visto por uma audiência proprietária.</em>
						</Style.LastProductInfo>
					</Flex>
				</Flex>
			</Card>
			<Card margin="32px 0">
				<Flex
					direction="column"
					padding="0"
					margin="0 0 32px"
				>
					<Style.Title>Um programa que não para de crescer!</Style.Title>
					<Style.Text margin="0 0 20px">
						A Webmotors TV está presente hoje em diversas regiões do Brasil e com o projeto
						de expandir ainda mais!
					</Style.Text>
					<Flex>
						<Card
							bgcolor={color.dark}
							margin="0 20px 0 0"
							display="flex"
							justifyContent="center"
							padding="0"
						>
							<Flex direction="row" align="center" justify="center" height="174px">
								<Flex direction="column" width="fit-content" justify="flex-end" margin="0">
									<Style.Content>
										<span>+1500</span>
									</Style.Content>
								</Flex>
								<Flex direction="column" width="fit-content" margin="0">
									<Style.Content>
										<p>municípios <br />cobertos.</p>
									</Style.Content>
								</Flex>
							</Flex>
						</Card>
						<Card
							bgcolor={color.dark}
							padding="0"
						>
							<Flex direction="row" align="center" justify="center" height="174px">
								<Flex direction="column" width="fit-content" justify="flex-end" margin="0">
									<Style.Content>
										<span className="viewers">+80<br /><em>milhões</em></span>
									</Style.Content>
								</Flex>
								<Flex direction="column" width="fit-content" margin="0">
									<Style.Content>
										<p>telespectadores <br />potencias.</p>
									</Style.Content>
								</Flex>
							</Flex>
						</Card>
					</Flex>
				</Flex>
				<Style.Title>Confira a programação</Style.Title>
				<Flex
					justify="space-around"
					padding="0"
					margin="22px 0"
				>
					<Map changeState setSelectedState={setSelectedState} selectedState={selectedState} width="666px" />
					<Style.TvCard>
						<IoMdArrowRoundUp size="2rem" onClick={() => changeChannel('previous')} className={currentChannel.id === 1 && 'disabled'} />
						{
						fadeStateClass && (
							<div
								className={fadeStateClass ? 'inner out' : 'inner in'}
								style={{ margin: '20px 0' }}
							>
								<Style.TvCardTitle data-test="state">
									{tvState.state}
								</Style.TvCardTitle>
								<div direction="column" className="tvcard">
									<Style.TvCardLabel>{currentChannel.place}</Style.TvCardLabel>
									<Flex align="center" margin="0 0 22px">
										<Style.TvCardLogo src={Logos[currentChannel.channel.channelLogo]} />
										<Style.TvCardText>{currentChannel.channel.channelName}</Style.TvCardText>
									</Flex>
									<Style.TvCardLabel>Quando:</Style.TvCardLabel>
									<Style.TvCardText>{currentChannel.airDate}</Style.TvCardText>
								</div>
							</div>
						)
					}
						<IoMdArrowRoundDown size="2rem" className={currentChannel.id === tvState.tvChannel.length && 'disabled'} onClick={() => changeChannel('next')} />
					</Style.TvCard>
				</Flex>
			</Card>
			<Flex justify="space-between">
				<Card
					margin="0 16px 0 0"
					height="280px"
					padding="0"
					width="calc(100% - 16px)"
					heightDesktop="420px"
				>
					<VideoFrame src="https://www.youtube.com/embed/HOwaYN6juTY?si=6WomH8oW-emTkszc" height="280px" />
				</Card>
				<Card margin="0 0 0 16px" padding="32px" height="280px" width="calc(100% - 16px)" heightDesktop="420px">
					<Flex direction="column" padding="0 20px 0 0" height="auto">
						<Flex margin="0">
							<Style.Text
								size={20}
								weight={fontWeight.medium}
								margin="0 0 10px 0"
							>
								Se interessou? <br /> Não perca essa oportunidade
							</Style.Text>
						</Flex>
						<Flex margin="0" width="100%">
							<Style.Text
								size={18.2}
								sizeDesktop={16}
								weight={fontWeight.regular}
								textColor={color.gray}
							>
								Entre em contato conosco clicando no botão abaixo.
								É só preencher o formulário de interesse e aguardar
								que um de nossos especialistas entrarão em contato com você!
							</Style.Text>
						</Flex>
					</Flex>
					<div style={{ position: 'absolute', bottom: '32px', right: '32px' }}>
						<Flex justify="flex-end" align="center">
							<Style.Material
								target="_blank"
								href={pdfFile}
							>
								Baixe aqui o material completo
							</Style.Material>
							<Button
								width="fit-content"
								display="table"
								padding="11px 22px"
								type="link"
								onClick={redirectForm}
								fontWeight={600}
								fontSize="12px"
							>
								Tenho interesse
							</Button>
						</Flex>
					</div>
				</Card>
			</Flex>
		</Flex>
	);
};

export default WithProduct;
